import React from 'react';
import PropTypes from 'prop-types';
import VerticalTabsItem from '../VerticalTabsItem';
import VerticalTabsContext from './VerticalTabsContext';
import { SIZE, SKIN } from './VerticalTabs.constants';
/** Vertical tabs navigation panel. */
const Footer = ({ children }) => (React.createElement(VerticalTabsItem, { type: "action" }, children));
const TabsGroup = ({ title = '', children }) => (React.createElement(React.Fragment, null,
    React.createElement(VerticalTabsItem, { type: "title" }, title),
    children));
TabsGroup.propTypes = {
    title: PropTypes.string,
};
const VerticalTabs = ({ dataHook, children, size = SIZE.MEDIUM, skin = SKIN.LIGHT, activeTabId, onChange, }) => {
    return (React.createElement(VerticalTabsContext.Provider
    // @ts-expect-error - didn't manage to make context work with components generics
    , { 
        // @ts-expect-error - didn't manage to make context work with components generics
        value: { size, skin, activeTabId, onChange } },
        React.createElement("div", { "data-hook": dataHook, "aria-orientation": "vertical", role: "tablist", "data-active-tab-id": activeTabId }, children)));
};
VerticalTabs.displayName = 'VerticalTabs';
VerticalTabs.TabsGroup = TabsGroup;
VerticalTabs.TabItem = VerticalTabsItem;
VerticalTabs.Footer = Footer;
VerticalTabs.propTypes = {
    size: PropTypes.any,
    activeTabId: PropTypes.any,
    onChange: PropTypes.func,
    children: PropTypes.arrayOf(PropTypes.node),
    dataHook: PropTypes.string,
}; // cast needed to prevent propTypes messing with generics
export default VerticalTabs;
//# sourceMappingURL=VerticalTabs.js.map